export function differenceInSeconds(date, dateToCompare) {
  var diff = date.getTime() - dateToCompare.getTime();

  return diff / 1000;
}
